module.exports = __webpack_public_path__ + "static/media/pdficon.0643646b.svg";